import * as echarts from 'echarts/core';
import { LineChart, BarChart, PieChart, GaugeChart } from 'echarts/charts';
import {
	GridComponent,
	TooltipComponent,
	LegendComponent,
	TitleComponent,
	GraphicComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
	LineChart,
	BarChart,
	PieChart,
	GaugeChart,
	GridComponent,
	TooltipComponent,
	LegendComponent,
	TitleComponent,
	GraphicComponent,
	CanvasRenderer
]);

export { echarts };

/** Smallest chart label size. */
export const CHART_FONT = 15;

/**
 * Read theme CSS variables for ECharts.
 * @returns {{ text: string, muted: string, accent: string, green: string, red: string, orange: string, line: string }}
 */
export function chartTheme() {
	const s = typeof document !== 'undefined'
		? getComputedStyle(document.documentElement)
		: { getPropertyValue: () => '' };
	const read = (name, fallback) => (s.getPropertyValue(name) || '').trim() || fallback;
	return {
		text: read('--app-primary-txt', '#e6e9f8'),
		muted: read('--app-tertiary-txt', '#9aa3c7'),
		accent: read('--score-blue-color', '#5b8def'),
		green: read('--score-green-color', '#4caf93'),
		red: read('--score-red-color', '#e45b73'),
		orange: '#e09a3e',
		line: 'rgba(168, 174, 222, 0.18)'
	};
}

/**
 * Shared tooltip / axis styling.
 * @param {ReturnType<typeof chartTheme>} t
 * @returns {object}
 */
export function baseChartOption(t) {
	return {
		animation: false,
		textStyle: { color: t.muted, fontFamily: 'inherit', fontSize: CHART_FONT },
		tooltip: {
			trigger: 'axis',
			backgroundColor: 'rgba(12, 16, 32, 0.92)',
			borderColor: t.line,
			textStyle: { color: t.text, fontSize: CHART_FONT }
		}
	};
}
